export default __webpack_public_path__ + "static/media/57.7b0d7775.png";